import { Box, Flex, Image } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import Logo from '@/assets/svg/logo.svg';

const pulseVariants = {
  pulse: {
    scale: [1, 1.12, 1],
    opacity: [1, 0.92, 1],
    transition: {
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut',
      times: [0, 0.5, 1],
    },
  },
};

export const PageLoader = () => {
  return (
    <Flex position="fixed" inset={0} bg="white" align="center" justify="center" zIndex={9999}>
      <Box as={motion.div} variants={pulseVariants} animate="pulse">
        <Image
          src={Logo}
          alt="Loading..."
          boxSize={{ base: '140px', md: '180px' }}
          objectFit="contain"
          filter="drop-shadow(0 8px 24px rgba(0,0,0,0.12))"
        />
      </Box>
    </Flex>
  );
};
